/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class Oauth2Service {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Used to perform OAuth2 login using MobileAuth as a proxy to given OAuth2 provider.
   * @param state Client side generated state. Should match state returned as get param in response.
   * @param redirectUri URL that user should be redirected to with `code` and `state` after sucessful OAuth2 login.
   * @param codeChallenge Code challenge for authorization with PKCE. Client must generate a random string between 43 and 128 characters long, URL-safe base64-encode SHA256 hash of that string and send here.
   * `code_challenge = SHA256(rand_string)`
   * Frontend needs to safe that `rand_string` as it will later be used to verify `code` when exchanging with access token.
   * For more details check [Authorization with PKCE](https://docs.gitlab.com/ee/api/oauth2.html#authorization-code-with-proof-key-for-code-exchange-pkce).
   * @param codeChallengeMethod An algorithm used to generate `code_challenge`.
   * @param projectId
   * @param providerId
   * @returns void
   * @throws ApiError
   */
  public getAuthOAuth2Flow(
    state: string,
    redirectUri: string,
    codeChallenge: string,
    codeChallengeMethod: 'S256',
    projectId?: string,
    providerId?: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/auth/oauth/{projectId}/{providerId}',
      path: {
        projectId: projectId,
        providerId: providerId
      },
      query: {
        state: state,
        redirect_uri: redirectUri,
        code_challenge: codeChallenge,
        code_challenge_method: codeChallengeMethod
      },
      errors: {
        302: `302 redirect to target OAuth2 provider`,
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used during OAuth2 flow to receive data from OAuth2 provider after OAuth2 login attempt.
   * @param state Client side generated state. Should match state returned as get param in response. Optional as OAuth2 provider may not provide this on failure.
   * @param code Optional as OAuth2 provider may not provide this on failure.
   * @param error String representing error returned by OAuth2 provider. Optional as OAuth2 provider will not provide this on success.
   * [Errors for Google OAuth2](https://developers.google.com/identity/protocols/oauth2/web-server#handlingresponse)
   * @returns void
   * @throws ApiError
   */
  public getAuthOAuth2FlowCallback(
    state?: string,
    code?: string,
    error?: string
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/auth/oauth/callback',
      query: {
        state: state,
        code: code,
        error: error
      },
      errors: {
        302: `302 redirect to redirect_url provided by project that initiated OAuth2 flow.`,
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
}
